export default {"src":"/_next/static/media/day.4039a7c3.svg","height":19,"width":18};